import { configureStore } from '@reduxjs/toolkit'
import { gatewaySlice } from '@utils/store/gateway'
import { notificationsSlice } from '@utils/store/notification'
import { organizationSlice } from '@utils/store/organization'
import { siteSlice } from '@utils/store/site'

/**
 * Root Redux store, combining the notifications, site, organization, and gateway slices.
 */
export default configureStore({
  reducer: {
    notifications: notificationsSlice.reducer,
    site: siteSlice.reducer,
    organization: organizationSlice.reducer,
    gateway: gatewaySlice.reducer
  }
})
